export const initSettingsModals = {
  addProductionNode: false,
  editCompanyData: false,
  addAddress: false,
  addContact: false,
  addWebPage: false,
  addCategory: false,
  addWorkAction: false,
};
